export const ATTENDANCE_STATUSES = [
  'Present',
  'Absent',
  'Half Day',
  'Leave',
  'Holiday',
  'Weekend'
];

export const LEAVE_TYPES = [
  'Sick Leave',
  'Casual Leave',
  'Paid Leave',
  'Unpaid Leave',
  'Maternity Leave',
  'Paternity Leave'
];

export const PAYMENT_FREQUENCIES = [
  'Weekly', 
  'Bi-Weekly', 
  'Monthly', 
  'Quarterly', 
  'Semi-Annually', 
  'Annually'
];

export const EMPLOYMENT_TYPES = ['Salaried', 'Hourly', 'Per-Visit'];

export const PAYROLL_STATUSES = ['Pending', 'Processed', 'Paid', 'Failed', 'Cancelled'];

export const PAYMENT_METHODS = ['Bank Transfer', 'Cash', 'Cheque', 'Online'];

export const MONTH_OPTIONS = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' }
];

export const YEAR_OPTIONS = (() => {
  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 2;
  const endYear = currentYear + 3;
  const years = [];
  for (let year = startYear; year <= endYear; year += 1) {
    years.push({ value: year, label: `${year}` });
  }
  return years;
})();

export const DEFAULT_PAGINATION = {
  page: 1,
  pages: 1,
  limit: 10,
  total: 0
};
